import ComponenteNumericoSubtipoModel from './ComponenteNumericoSubtipoModel'
import TiposDeComponentesEnum from './TiposDeComponentesEnum'

export default class Componente {
  constructor({ id = 0,
    idFormularioSecao = 0,
    idElementoTipo = 0,
    dataCadastro = null,
    dataUltimaAlteracao = null,
    nome = '',
    label = '',
    texto = null,
    obrigatorio = false,
    multiline = false,
    linha = 0,
    coluna = 0,
    maxLength = null,
    visivel = true,
    opcoes = [],
    tipo = null,
    elementoEncadeado = null,
    template = null,
    nomeComponenteEmail = null,
    anexos = [],
    componenteNumericoSubtipoId = null,
    componenteNumericoSubtipo = new ComponenteNumericoSubtipoModel(),
  } = {}) {
    this.id = id
    this.idFormularioSecao = idFormularioSecao
    this.idElementoTipo = idElementoTipo
    this.dataCadastro = dataCadastro
    this.dataUltimaAlteracao = dataUltimaAlteracao
    this.nome = nome
    this.label = label
    this.texto = texto
    this.obrigatorio = obrigatorio
    this.multiline = multiline
    this.linha = linha
    this.coluna = coluna
    this.maxLength = maxLength
    this.visivel = visivel
    this.opcoes = opcoes
    this.tipo = tipo
    this.elementoEncadeado = elementoEncadeado
    this.template = template
    this.nomeComponenteEmail = nomeComponenteEmail
    this.anexos = anexos
    this.componenteNumericoSubtipoId = componenteNumericoSubtipoId
    this.componenteNumericoSubtipo = componenteNumericoSubtipo
  }

  static listarComponentesEncadeados(elementoEncadeado) {
    const encadeados = []
    let current = elementoEncadeado

    if (current === null) return null

    while (current !== null) {
      encadeados.push({
        ...current,
        elementoEncadeado: null,
      })
      current = current.elementoEncadeado
    }

    return encadeados
  }

  static getArrayDeComponentesEncadeadosComDadosDefault(length, linha, coluna) {
    return Array.from({ length }, (_, index) => {
      const obj = new Componente({
        linha,
        coluna,
        visivel: true,
        multiline: null,
        idElementoTipo: index < length - 1 ? TiposDeComponentesEnum.DropDownList : 0,
      })

      return obj
    })
  }

  static aninharComponentesEncadeados(encadeados) {
    let objeto = {}
    let objetoAnterior = null

    for (let i = encadeados.length - 1; i >= 0; i -= 1) {
      const novoObjeto = { ...encadeados[i], elementoEncadeado: objetoAnterior }
      objetoAnterior = novoObjeto
      if (i === 0) {
        objeto = novoObjeto
      }
    }

    return objeto
  }
}
